var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-form',{attrs:{"name":this.$route.name,"title":"Recover Password","sub-title":"Create a strong password."}})
}
var staticRenderFns = []

export { render, staticRenderFns }